// extracted by mini-css-extract-plugin
export default {"container":"aDjo3j","floatingText":"C16w3l"};